import React, { memo } from 'react';
import cn from 'classnames';
import { FADED_ICON_ERROR, LIGHT_BLUE } from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGE } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';
import { IOutlinedTextFieldProps, ITextFieldProps, NeoTextField } from './NeoTextField';

const useStyles = makeStyles(() => ({
  textFieldWithIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 50,
    width: '100%',
    boxSizing: 'border-box',
  },
  textFieldWithIconIcon: {
    width: 30,
    height: 30,
    backgroundColor: LIGHT_BLUE,
    borderRadius: 30,
    marginRight: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&>svg': {
      fontSize: FONT_SIZE_LARGE,
    },
  },
  textFieldWithIconInput: {
    flex: 1,
    display: 'flex',
  },
  error: {
    backgroundColor: FADED_ICON_ERROR,
  },
}));

export const NeoTextFieldWithIcon = memo(
  ({ icon, className, ...props }: ITextFieldProps | IOutlinedTextFieldProps) => {
    const { classes } = useStyles();
    return (
      <div
        className={cn(classes.textFieldWithIconWrapper, className, {
          [classes.error]: props.error,
        })}
      >
        <div className={classes.textFieldWithIconIcon}>{icon}</div>
        <div className={classes.textFieldWithIconInput}>
          <NeoTextField {...props} />
        </div>
      </div>
    );
  },
);
